"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocale = void 0;
const LocaleContext_1 = require("./LocaleContext");
const react_1 = require("react");
exports.useLocale = () => {
    const { localeId } = react_1.useContext(LocaleContext_1.localeContext);
    return localeId;
};
//# sourceMappingURL=useLocale.js.map